// =====================================================
// WeLearn Pro Player - Option module
// =====================================================

import Debug from './util/debugHelper';

export default class urlOptions {
    constructor(player) {
        this.player = player;
        this.debug = new Debug(this.player.options.debug);
    }

    getOptionsFromUrl() {
        // Get special command from query strings
        const search = window.location.search;
        const params = new URLSearchParams(search);
        let paramObj = {};

        for (var value of params.keys()) {
            paramObj[value] = params.get(value);
        }

        return paramObj;
    }

    applyOption(option, value) {
        switch (option) {
            case "startat":
                this.player.plyrPlayer.currentTime = Number(value);
                break;
            case "autoplay":
                if (value == 1) {
                    const playPromise = this.player.plyrPlayer.play();

                    if (playPromise.length) {
                        playPromise.catch(() => {
                            this.player.plyrPlayer.play();
                        });
                    }
                }
            default:
                break;
        }
    }
}